import React from 'react';
import { connect, ConnectedProps } from '@cerebral/react';
import { state, sequences } from 'app/pwa/app.cerebral';
import dayjs, { extend } from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import { INDICATOR } from 'resources/constants';
import { useText } from 'common/hooks';

extend(relativeTime);

import {
  Modal,
  UpperWrapper,
  Heading,
  Content1,
  Content2,
  StartButton,
  MoreButton,
  ExpandedWrapper,
  DetailsWrapper,
  DetailsTitle,
  DetailsText,
  Footer,
} from './elements';

const deps = {
  challenge: state.challenge.campaign.challenge,
  campaignIndicator: state.challenge.campaign.indicator,
  campaignTopic: state.challenge.campaign.topic,
  userName: state.appContainer.profiles[state.appContainer.user.uid].firstName,
  showExpandedIntro: state.challenge.tutorial.showExpandedIntro,
  expandIntroModal: sequences`challenge.tutorial.expandIntroModal`,
  beginTutorial: sequences`challenge.tutorial.beginTutorial`,
};

export function IntroModal({
  challenge,
  campaignIndicator = INDICATOR.co2,
  campaignTopic = 'co2',
  userName,
  showExpandedIntro,
  expandIntroModal,
  beginTutorial,
}: typeof deps & ConnectedProps): React.ReactElement {
  if (!challenge) return null;

  const t = useText();

  return (
    <Modal
      onHide={() =>
        beginTutorial({
          offset: 460,
          activityKey: 'activity_tutorial_01',
        })
      }
      show
    >
      <UpperWrapper>
        <Heading>
          {t(`challenge.GMod09.heading_${campaignTopic}`, {
            userName: userName,
          })}
        </Heading>
        <Content1>
          {t(`challenge.GMod09.intro_${campaignTopic}`, {
            duration: dayjs(challenge.startDatetime).from(
              dayjs(challenge.endDatetime),
              true
            ),
          })}
        </Content1>
        <Content2>
          {t(`challenge.GMod09.tagline_${campaignTopic}_${campaignIndicator}`)}
        </Content2>
        <StartButton
          onClick={() =>
            beginTutorial({
              offset: 460,
              activityKey: 'activity_tutorial_01',
            })
          }
        >
          {t('challenge.GMod09.start_button')}
        </StartButton>
        <MoreButton
          disabled={showExpandedIntro}
          onClick={() => expandIntroModal()}
        >
          {t('challenge.GMod09.more_button')}
        </MoreButton>
      </UpperWrapper>
      <ExpandedWrapper shown={showExpandedIntro}>
        <DetailsWrapper>
          <DetailsTitle>{t('challenge.GMod09.details_title1')}</DetailsTitle>
          <DetailsText>{t('challenge.GMod09.details_text1')}</DetailsText>
          <DetailsTitle>{t('challenge.GMod09.details_title2')}</DetailsTitle>
          <DetailsText>{t('challenge.GMod09.details_text2')}</DetailsText>
          <DetailsTitle>{t('challenge.GMod09.details_title3')}</DetailsTitle>
          <DetailsText>{t('challenge.GMod09.details_text3')}</DetailsText>
          <DetailsTitle>{t('challenge.GMod09.details_title4')}</DetailsTitle>
          <DetailsText>{t('challenge.GMod09.details_text4')}</DetailsText>
          <DetailsTitle>{t('challenge.GMod09.details_title5')}</DetailsTitle>
          <DetailsText>{t('challenge.GMod09.details_text5')}</DetailsText>
          <DetailsTitle>{t('challenge.GMod09.details_title6')}</DetailsTitle>
          <DetailsText bottom>
            {t('challenge.GMod09.details_text6')}
          </DetailsText>
        </DetailsWrapper>
        <Footer
          text={t('challenge.GMod09.footer')}
          onClick={() =>
            beginTutorial({
              offset: 460,
              activityKey: 'activity_tutorial_01',
            })
          }
        />
      </ExpandedWrapper>
    </Modal>
  );
}

export default connect(deps, IntroModal);
